import gsap from 'gsap';

export default class {
    constructor(){
        
        const linkAnimation = document.querySelector('.p-kawasakiworld__link--item')
        if(linkAnimation){
            const p = linkAnimation.querySelectorAll('.ln')
            p.forEach( n => {
                let str = ""
                let text = n.innerText.split("")

                text.forEach( (t) => {
                    str += '<span class="js-text__animation">' + t + '</span>'
                })

                n.innerHTML = '<span class="-p">' + str + '</span>' + '<span class="-f">' + str + '</span>'
            })

            linkAnimation.addEventListener("mouseenter",() => {
                gsap.fromTo('.js-link-hover-animation .-f .js-text__animation',{
                    y:'100%',
                },{
                    y:0,
                    stagger: 0.01,
                    duration:.8,
                    ease:"Expo.easeOut"
                })
                gsap.fromTo('.js-link-hover-animation .-p .js-text__animation',{
                    y:0,
                },{
                    y:'-100%',
                    stagger: 0.01,
                    duration:.8,
                    ease:"Expo.easeOut"
                })
            })

            linkAnimation.addEventListener("mouseleave",() => {
                gsap.fromTo('.js-link-hover-animation .-f .js-text__animation',{
                    y:0,
                },{
                    y:'100%',
                    stagger: 0.01,
                    duration:.8,
                    ease:"Expo.easeInOut"
                })
                gsap.fromTo('.js-link-hover-animation .-p .js-text__animation',{
                    y:'-100%',
                },{
                    y:0,
                    stagger: 0.01,
                    duration:.8,
                    ease:"Expo.easeInOut"
                })
            })
        }
        // gsap.to(heroCatch,{
        //     opacity:1
        // })
        // gsap.fromTo('.js-text__animation',{
        //     y:'100%',
        // },{
        //     y:0,
        //     stagger: 0.05,
        //     delay :.3,
        //     duration:.7,
        //     ease:"Expo.easeOut"
        // })
        

    }
}
